export default __webpack_public_path__ + "static/media/Dashboard_SignIn.17f5dab1.png";